import React from 'react';

import Button from './Button';

interface BurgerButtonProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const BurgerButton: React.FC<BurgerButtonProps> = ({ open, setOpen }) => {
  return (
    <Button
      type="button"
      aria-label={open ? 'Close menu' : 'Open menu'}
      iconName={open ? 'HiXMark' : 'HiBars3'}
      iconSize="xxlarge"
      iconPosition="icon-only"
      colorScheme="scheme2"
      onClick={() => setOpen(!open)}
    />
  );
};

export default BurgerButton;
